import { render, staticRenderFns } from "./CourseMember.vue?vue&type=template&id=80a6dc02&scoped=true&"
import script from "./CourseMember.vue?vue&type=script&lang=js&"
export * from "./CourseMember.vue?vue&type=script&lang=js&"
import style0 from "./CourseMember.vue?vue&type=style&index=0&id=80a6dc02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a6dc02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
